/* eslint-disable */
import { connect } from 'react-redux';
import YakChat from '../../components/tack_ai_chat/yak_chat';
import { sendYakMessage, addAiMessage, resetChat } from '../../stores/tack_ai_chat/actions';
import { unreadCount } from '../../stores/tack_notifications/actions';

const mapStateToProps = (state) => ({
  messages: state.yakChat.get('messages'),
  isLoading: state.yakChat.get('isLoading'),
  isChatSessionComplete: state.yakChat.get('isChatSessionComplete'),
  error: state.yakChat.get('error'),
  accuracyOfLastAttempt: state.yakChat.get('accuracyOfLastAttempt'),
  lastGuessNumber: state.yakChat.get('lastGuessNumber'),
  email: state.user.get('email')
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSend: (text) => dispatch(sendYakMessage(ownProps.tackSlug, text)),
  onAddAiMessage: (text) => dispatch(addAiMessage(text)),
  onResetChat: () => dispatch(resetChat()),
  onResetUnreadCount: () => dispatch(unreadCount())
});

export default connect(mapStateToProps, mapDispatchToProps)(YakChat);


// WEBPACK FOOTER //
// ./src/containers/tack_ai_chat/yak_chat.js